import React from 'react';
import fr from 'facet-rest';
import {
  FDListItem,
  FDListItemText,
  FDListItemSecondary,
  FDSecondaryActionIconButton,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { loadModalCollectionByLink, refreshModalCollection } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [loading, setLoading] = React.useState(false);

  const handleRemove = async () => {
    try {
      setLoading(true);
      await resource.delete();
      refreshModalCollection();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FDListItem onClick={() => {
      resource.withRelationship(fr.relationships.edit.name, (rel) => {
        loadModalCollectionByLink(rel.link('related').url());
      },
      () => null);
    }}
    >
      <FDListItemText primaryText={resource.attr('primaryText')} secondaryText={'Click to edit'} />
      <FDListItemSecondary>
        <FDSecondaryActionIconButton icon="delete" onClick={handleRemove} loading={loading} />
      </FDListItemSecondary>
    </FDListItem>
  );
};

Layout.propTypes = {
};

export default Layout;
